import React, { useCallback } from "react";

import theme from "theme";
import { colors } from "theme/palette";

import Tabs, { Tab } from "components/Tabs";

import { IAssetManagementCategory } from "entities/AssetManagement/sdk";

interface IAssetManagementTabs {
  tabs: Array<IAssetManagementCategory>;
  selectedTab: IAssetManagementCategory;
  onChange: (tab: IAssetManagementCategory) => void;
}

const AssetManagementTabs: React.FC<IAssetManagementTabs> = ({
  tabs,
  onChange,
  selectedTab,
}) => {
  const handleChange = useCallback(
    (_: any, tabKey: string) => {
      onChange(tabs.find((tab) => tab.name === tabKey) || selectedTab);
    },
    [onChange, tabs, selectedTab]
  );

  return (
    <Tabs
      value={selectedTab.name}
      onChange={handleChange}
      sx={{
        borderBottom: `1px solid ${colors.blue100}`,
        minHeight: "40px",
      }}
      data-testid="asset-mgmt-tabs"
    >
      {tabs.map(({ id, name }) => (
        <Tab
          key={id}
          label={name}
          value={name}
          sx={{
            padding: theme.spacing(1, 2),
            color: colors.black,
            minHeight: "40px",
            "&.Mui-selected": {
              color: colors.black,
              backgroundColor: "#EEEEFF",
            },
          }}
          data-testid="asset-mgmt-tab"
        />
      ))}
    </Tabs>
  );
};

export default AssetManagementTabs;
